// Module
var code = `<form name="\$ctrl.form">
  <table class="table">
    <tbody>
      <tr>
        <td>Print name:</td>
        <td>
          <input type="text"
                 disabled
                 ng-value="\$ctrl.basePrint.name"
          />
        </td>
      </tr>
      <tr ng-repeat="(parameterName, parameterValue) in \$ctrl.printParameters">
        <td>{{\$ctrl.translate(parameterName)}}</td>
        <td>
          <select
            required
            class="form-control"
            ng-model="\$ctrl.parameters[parameterName]"
            ng-options="type.id as type.label for type in \$ctrl.printParameters[parameterName]">
          </select>
        </td>
      </tr>
    </tbody>
  </table>
  <div class="flex-end buttons">
    <a class="btn btn-warning"
       ng-href="/#!/admin/prints">
      Cancel
    </a>
    <button class="btn btn-primary"
       type="button"
       ng-disabled="\$ctrl.form.\$invalid"
       ng-click="\$ctrl.configurePrint()">
      Customize print
    </button>
  </div>
</form>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/prints/prints-customization.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;